<template>
  <div class="page flex componentPage">
      <!-- 订单列表页 -->
      <div class='orderlist flex' v-if='!detailVisible'>
          <el-form :inline="true" :model="form" class='flexForm' v-if='!orderId'>
            <el-col :span='5'>
                <el-form-item>
                    <el-input placeholder="订单编号、产品名、借款人姓名、身份证、手机号" v-model="form.keyWord"></el-input>
                </el-form-item>
            </el-col>
            <el-form-item label=" ">
                <el-select v-model="form.orderStatus" clearable placeholder="请选择订单状态">
                    <el-option v-for="item in getOrderStatus" :key="item.codeKey" :label="item.codeKey" :value="item.codeValue"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label=" ">
                <el-select v-model="form.period" clearable placeholder="请选择期数" clearable>
                    <el-option v-for="item in getPeriod" :key="item.codeKey" :label="item.codeKey" :value="item.codeValue"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label=" ">
                <el-select v-model="form.channelId" clearable placeholder="请选择渠道商" clearable>
                    <el-option v-for="item in getChannel" :key="item.codeKey" :label="item.codeKey" :value="item.codeValue"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label=" ">
                <el-date-picker placeholder="请选择借款时间" v-model="form.date" type='date' format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="buttonTeam floatNone">
                <el-button type="primary" @click="getUser" icon='el-icon-search'></el-button>
            </el-form-item>
        </el-form>
        <!-- <el-col :span='4'><el-button type="primary" @click="add">添加</el-button></el-col> -->
        <el-table :data='dataList' border height="100%" v-loading='tableLoading' style='min-height:300px;'>
            <el-table-column type='index'  label='序号' width="80"></el-table-column>
            <el-table-column prop="orderNo" label="订单编号" width='200'/>
            <el-table-column prop="orderStatusName" label="订单状态" width='115'>
                <!-- <template slot-scope='{row}' >{{checkOrderStatus(row.orderStatus).codeKey || checkOrderStatus(row.orderStatus)}}</template> -->
            </el-table-column>
                <!-- <el-table-column prop="creator" label="创建人"/> -->
                <el-table-column prop="productName" label="产品名称" width='200'/>
                <el-table-column prop="trueName" label="申请人" width='100'/>
                <el-table-column prop="identifyId" label="身份证" width='200'/>
                <el-table-column prop="mobile" label="手机号" width='150'/>
                <el-table-column prop="amount" label="申请金额" width='100'/>
                <el-table-column prop="periodName" label="申请期数" width='80'>
                    <!-- <template v-slot='{row}' v-if='getPeriod.length>0'>
                        {{checkPeriod(row.period).codeKey}}
                    </template> -->
                </el-table-column>
                <el-table-column prop="createDate" label="申请时间" width='180'>
                    <!-- <template slot-scope="{row}">{{$date.format(row.createDate, "YYYY-MM-DD HH:mm:ss")}}</template> -->
                </el-table-column>
                <el-table-column prop="channelName" label="渠道商" width='100'/>
                <el-table-column prop="createDate" label="操作" width='115' fixed="right">
                    <template slot-scope="{row}">
                        <el-button type='warning' size='mini' @click="orderDetail(row)">订单详情</el-button>
                    </template>
                </el-table-column>
        </el-table>
        <div class='tablepage'>
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-size='pageSize'
            @current-change='getUser'
            :page-sizes="[10,20,30,40]"
            @size-change='sizeChange'
            :current-page.sync="current"
            :total="total">
        </el-pagination>
      </div>
      </div>
      <!-- 订单详情页面 -->
      <div class='orderDetail' v-if='detailVisible'>
          <order-detail @back='back' :user='userRow'/>
      </div>
        <!-- <el-dialog :title='title' :visible.sync="visible" width="500px">
          <user-info :params='params' :close='close'/>
      </el-dialog> -->
  </div>
</template>

<script>
import orderDetail from '@/components/orderDetail.vue'
import {mapGetters} from 'vuex'
import { store, mutation } from '@/util/observable.js'
  export default {
    data () {
      return {
          form: {},
          dataList: [],
          title: '新增用户',
          visible: false,
          params: {},

          current:1,
          total: 0,
          pageSize: 10,
          tableLoading:false, // 表格加载刷新参数
          detailVisible:false, //订单详情页面的展示与否,
          userRow:null
      }
    },
    props:{
        orderId:{default:null}
    },
    components: {
        orderDetail
    },
    computed:{
        ...mapGetters([
            'getOrderStatus',
            'checkOrderStatus',
            'getChannel',
            'getPeriod',
            'checkPeriod'
        ])
    },
   methods: {
       async getUser(){
           this.tableLoading = true
           if(this.orderId) this.form.keyWord = this.orderId
           let params = {
               ...{current:this.current,pageSize:this.pageSize},
               ...this.form
           }
           const rsp = await this.$http.getAllOrder(params)
           this.tableLoading = false
           if(rsp.code != 200) return
           this.dataList = rsp.data.records
           this.total = rsp.data.total
       },
       sizeChange(val){
           this.pageSize = val
           this.getUser()
       },
       close(){
           this.visible = false
           this.getUser()
       },
       add(){
           this.params = {}
           this.visible = true
           this.title = '新增用户'
           this.params = {}
       },
       orderDetail(row){
           this.detailVisible = true
           this.userRow = row
           mutation.editer(row)
           console.log(store)
       },
       //父子组件通信
       back(){
           this.detailVisible = false
       }
   },
   watch:{
       orderId(old,newvl){
           this.getUser()
       }
   },
   created(){
       this.getUser()
       console.log(this.$children)
   }
    }
</script>

<style scoped lang='scss'>
.page{flex-direction: column;}
.orderlist{
    flex-direction: column;
    flex: 1;
}
.orderDetail{
    height: 100%;
    overflow: hidden;
    /deep/.el-tabs{
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .el-tabs__content{
            flex: 1;
            overflow-y: auto;
        }
}
} 
</style>
